import { createContext, useContext, useState } from "react";
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [darkmode, setDarkmode] = useState(
        document.body.classList.contains("dark")
    );
    
  return <ThemeContext.Provider value={{darkmode, setDarkmode}}>{children}</ThemeContext.Provider>;
};

export const useDarkmode = () => {
  return useContext(ThemeContext);
};

